import {DossierItemType} from "const/DossierItemType"

export default {
  title: "Dossier search",
  input: {
    type: {
      label: "Dossier item type",
      option: {
        [DossierItemType.note]: "Note",
        [DossierItemType.email]: "Email",
        [DossierItemType.invoice]: "Invoice",
      },
    },
    subject: "Subject"
  }
}
